import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState, useContext } from 'react';
import { View } from 'react-native';
import { Cascader } from '../../Cascader/rn';
import { useLocale } from '../../LocaleProvider/rn';
import { ConfigContext } from '../../ConfigProvider/rn/context';
import { BTN_CHOOSE_ISSUE } from '../../../utils/constants';
var defaultPopupProps = {
  show: false,
  title: '',
  buttons: []
};
export var OptionSelector = function OptionSelector(props) {
  var _useContext = useContext(ConfigContext),
    translations = _useContext.translations;
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var _useState = useState(_objectSpread(_objectSpread({}, defaultPopupProps), {}, {
      onClose: function onClose() {
        return setPopupData(_objectSpread(_objectSpread({}, popupData), defaultPopupProps));
      }
    })),
    _useState2 = _slicedToArray(_useState, 2),
    popupData = _useState2[0],
    setPopupData = _useState2[1];
  var styles = props.styles,
    content = props.content,
    options = props.options,
    titleTextStyles = props.titleTextStyles,
    isUIOptimisationRecommender = props.isUIOptimisationRecommender;
  var updatePopupData = function updatePopupData(data) {
    setPopupData(_objectSpread(_objectSpread({}, popupData), data));
  };
  var handleOptionClick = function handleOptionClick(option) {
    return function () {
      var _option$subOptions;
      ((_option$subOptions = option.subOptions) === null || _option$subOptions === void 0 ? void 0 : _option$subOptions.length) && updatePopupData({
        show: true,
        title: (translations === null || translations === void 0 ? void 0 : translations.btn_choose_issue) || trans(BTN_CHOOSE_ISSUE),
        buttons: option.subOptions.map(function (subOption) {
          return _objectSpread(_objectSpread({}, subOption), {}, {
            onClick: function onClick() {
              return updatePopupData(defaultPopupProps);
            }
          });
        })
      });
    };
  }; // borderColor和borderWidth的设置，用于解决部分安卓机型，最后一个btn文字溢出的问题

  options.forEach(function (option) {
    option.styles = option.styles || {
      containerStyle: {}
    };
    if (option.styles.containerStyle) {
      // @ts-ignore
      option.styles.containerStyle.borderColor = '#ffffff'; // @ts-ignore

      option.styles.containerStyle.borderWidth = 1;
    }
  });
  var cascaderProps = {
    styles: styles,
    content: content,
    titleTextStyles: titleTextStyles,
    buttonGroup: {
      styles: styles,
      buttons: options.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          onClick: handleOptionClick(option)
        });
      })
    },
    popupProps: popupData,
    isUIOptimisationRecommender: isUIOptimisationRecommender
  };
  return /*#__PURE__*/React.createElement(View, {
    style: styles
  }, /*#__PURE__*/React.createElement(Cascader, cascaderProps));
};